import { render, staticRenderFns } from "./UnitMappingItem.vue?vue&type=template&id=c95e6b1c&scoped=true&"
import script from "./UnitMappingItem.vue?vue&type=script&lang=js&"
export * from "./UnitMappingItem.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "c95e6b1c",
  null
  
)

export default component.exports